import { DateTime } from 'luxon'
import sortBy from 'lodash/fp/sortBy'
import { markdownToDraft } from 'markdown-draft-js'
import {
  isAdultAgeGroupEvent,
  isJuniorAgeGroupEvent,
} from 'utils/groupEventUtils'

const sortedSessions = sortBy(session => session.startDateTime)

const dateTimeForForm = (dateTime, timezone) => {
  if (!dateTime) return null

  return DateTime.fromISO(dateTime)
    .setZone(timezone)
    .setZone('local', { keepLocalTime: true })
}

const makeDefaultValues = ({
  title,
  startDateTime,
  endDateTime,
  coachFacility,
  maxAttendance,
  tags,
  featuredImageUrl,
  description,
  priceInCents,
  registrationCloseDateTime,
  registrationOpenDateTime,
  paymentAccount,
  paymentRecurrenceSchedule,
  sessions,
  externalRegistrationUrl,
  unlisted,
  accessCode,
  timezone,
  assistantCoaches,
}) => ({
  title,
  maxAttendance,
  startDate: DateTime.fromISO(startDateTime)
    .setZone(timezone)
    .setZone('local', { keepLocalTime: true })
    .toJSDate(),
  startTime: DateTime.fromISO(startDateTime)
    .setZone(timezone)
    .setZone('local', { keepLocalTime: true })
    .toJSDate(),
  registrationCloseDate: dateTimeForForm(registrationCloseDateTime, timezone),
  registrationCloseTime: dateTimeForForm(registrationCloseDateTime, timezone),
  registrationOpenDate: dateTimeForForm(registrationOpenDateTime, timezone),
  registrationOpenTime: dateTimeForForm(registrationOpenDateTime, timezone),
  endTime: DateTime.fromISO(endDateTime)
    .setZone(timezone)
    .setZone('local', { keepLocalTime: true })
    .toJSDate(),
  locationId: coachFacility.id,
  tags,
  featuredImageUrl,
  externalRegistrationUrl,
  paymentRecurrenceSchedule,
  description: JSON.stringify(markdownToDraft(description)),
  price: (priceInCents / 100).toFixed(2),
  paymentAccountId: paymentAccount?.id,
  sessions: sortedSessions(sessions).map(s => ({
    id: s.id,
    startDate: DateTime.fromISO(s.startDateTime)
      .setZone(timezone)
      .setZone('local', { keepLocalTime: true }),
    startTime: DateTime.fromISO(s.startDateTime)
      .setZone(timezone)
      .setZone('local', { keepLocalTime: true }),
    endTime: DateTime.fromISO(s.endDateTime)
      .setZone(timezone)
      .setZone('local', { keepLocalTime: true }),
  })),
  unlisted,
  accessCode: accessCode || '',
  assistantCoachIds: assistantCoaches.map(coach => coach.id),
  ageGroup: isAdultAgeGroupEvent(tags)
    ? 'adults-only'
    : isJuniorAgeGroupEvent(tags)
      ? 'juniors-only'
      : 'all-ages',
})

export default makeDefaultValues
